'use client';

import { c as _c } from "react/compiler-runtime";
import type { ListHometownNewsDto } from '@generated/unauth';
import useEmblaCarousel from 'embla-carousel-react';
import { RecommendHometownNewsVerticalCard } from './RecommendHometownNewsVerticalCard';
interface RecommendHometownNewsProps {
  id?: string;
  list: ListHometownNewsDto[];
}
export const RecommendHometownNews = t0 => {
  const $ = _c(9);
  const {
    id,
    list
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  if (list.length < 1) {
    return null;
  }
  let t2;
  if ($[1] !== id) {
    t2 = <h4 className="pb-16 pl-20 pt-32 font-700 text-Gray-900 typo-body1" id={id}>이런 이야기는 어때요?</h4>;
    $[1] = id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== emblaRef || $[4] !== list) {
    t3 = list.length > 0 ? <div className="m-0 mb-20 overflow-hidden pl-20" ref={emblaRef}><div className="flex gap-12">{list.map(_temp)}</div></div> : null;
    $[3] = emblaRef;
    $[4] = list;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <article className="flex flex-col border-t-[6px] border-Gray-200 bg-Gray-white pb-30">{t2}{t3}</article>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(news) {
  return <div key={news.hometownNewsId} className="w-fit flex-[0_0_auto] last:mr-20"><RecommendHometownNewsVerticalCard key={news.hometownNewsId} className="select-none" idIdx={news.hometownNewsIdIdx} daysAgo={news.daysAgo} name={news.hometownNewsName} thumbnail={news.thumbnail} /></div>;
}